import { Skeleton } from '@mui/material';
import { ConditionalLoaderProps } from './ConditionalLoader.props';

const ConditionalLoader = ({ isLoading, children, width = 150, height = 20 }: ConditionalLoaderProps) =>
  isLoading ? <Skeleton variant="text" width={width} height={height} /> : children;

export default ConditionalLoader;
